var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-statement"},[_vm._m(0),_c('p',[_vm._v(" 如果以上内容存在第三方版权内容，则由网络爬虫自动抓取，以非人工方式自动生成。Bubianli.com 不储存、复制、传播任何第三方版权文件。 ")]),_c('p',[_vm._v("copyright © "+_vm._s(_vm.copyyear)+" bubianli.com")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("微博: "),_c('a',{attrs:{"href":"https://weibo.com/u/2231809290","target":"__blank"}},[_vm._v("果仁菠菜 JIA")])])
}]

export { render, staticRenderFns }